
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/showcase",
      function () {
        return require("private-next-pages/user/showcase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/showcase"])
      });
    }
  